var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[(_vm.loaded)?_c('ProfileHeader'):_vm._e(),_c('hr'),_c('vca-row',[_c('vca-card',{staticClass:"shadowed"},[_c('div',{staticClass:"vca-center avatar-container"},[_c('img',{attrs:{"src":_vm.avatarURL}})])]),_c('ProfileData'),_c('ProfileBulkRoles')],1),_c('vca-row',[_c('ProfileParticipants')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }